// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__LnJKI","search":"Settings_search__3vALs","filter":"Settings_filter__EWInG"};